import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { HubConnectionState } from "@microsoft/signalr";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { InternetGateway } from "../../enum";
import "./DroneControlTopPanel.css";
import { useSignalR } from "../../hooks";
import { BatteryIndicator } from "../BatteryIndicator/BatteryIndicator";
import { MotorsIndicator } from "../MotorsIndicator/MotorsIndicator";
export const DroneControlTopPanel = ({ controlType, isViewOnly }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isDroneOnline, setIsDroneOnline] = useState(false);
    const [isOperatorOnline, setIsOperatorOnline] = useState(false);
    const [batteryStatus, setBatteryStatus] = useState();
    const [gatewayStatus, setGatewayStatus] = useState(InternetGateway.Auto);
    const [selectedGateway, setSelectedGateway] = useState(InternetGateway.Auto);
    const [showConnectionManagement, setShowConnectionManagement] = useState(false);
    const [pingStats, setPingStats] = useState(null);
    const [motorStatus, setMotorStatus] = useState();
    const [isBatteryShow, setBatteryShow] = useState(false);
    const [batteryLimits, setBatteryLimits] = useState(null);
    const [motorsLimits, setMotorsLimits] = useState(null);
    const connection = useSignalR();
    useEffect(() => {
        console.log("Connection 1111:", connection);
        if (connection) {
            connection.onclose((e) => {
                if (e && e.message.indexOf("Token is not valid") !== -1) {
                    navigate("/dashboard");
                }
                setIsOperatorOnline(false);
            });
            connection.onreconnecting(() => {
                setIsOperatorOnline(false);
            });
            connection.onreconnected(async () => {
                setIsOperatorOnline(true);
            });
            connection.on("DroneConnected", onDroneConnected);
            connection.on("Status", onStatus);
            connection.on("DroneDisconnected", onDroneDisconnected);
            connection.on("UpdateBatteryStatus", onUpdateBatteryStatus);
            connection.on("UpdateBldcStatus", onUpdateMotorsStatus);
            connection.on("UpdateGatewayStatus", onUpdateGatewayStatus);
            setIsOperatorOnline(true);
            return () => {
                connection.off("DroneConnected", onDroneConnected);
                connection.off("Status", onStatus);
                connection.off("DroneDisconnected", onDroneDisconnected);
                connection.off("UpdateBatteryStatus", onUpdateBatteryStatus);
                connection.off("UpdateBldcStatus", onUpdateMotorsStatus);
                connection.off("UpdateGatewayStatus", onUpdateGatewayStatus);
            };
        }
    }, [connection]);
    const onDroneConnected = () => {
        if (connection && connection.state == HubConnectionState.Connected) {
            connection.invoke("SwitchGateway", selectedGateway);
            setIsDroneOnline(true);
        }
    };
    const onStatus = (status) => {
        setShowConnectionManagement(status.isConnectionManagement);
        setBatteryLimits(status.batteryLimitValues);
        setMotorsLimits(status.motorLimitValues);
        setIsDroneOnline(true);
    };
    const onDroneDisconnected = () => {
        setIsDroneOnline(false);
    };
    const onUpdateBatteryStatus = (data) => {
        setBatteryStatus(data);
    };
    const onUpdateMotorsStatus = (data) => {
        setMotorStatus(data);
    };
    const onUpdateGatewayStatus = (data) => {
        setGatewayStatus(data.currentGateway);
        setPingStats(data.pingStatistics);
    };
    const switchInternetGateway = (gateway) => {
        if (connection) {
            setSelectedGateway(gateway);
            connection.invoke("SwitchGateway", gateway);
        }
    };
    return (_jsx("div", { className: "controller-top-wrapper", children: _jsxs(_Fragment, { children: [_jsx("div", { className: "controller-speed" }), _jsx("div", { className: "battery-indicator", children: batteryStatus && (_jsx(BatteryIndicator, { bmsStatus: batteryStatus, batteryLimits: batteryLimits, setBatteryShow: setBatteryShow, isBatteryShow: isBatteryShow })) }), _jsx("div", { className: `battery-indicator motor-indicator ${isBatteryShow && "motor-wrapper-bottom"}`, children: motorStatus && (_jsx(MotorsIndicator, { motorsData: motorStatus, motorsLimits: motorsLimits })) }), _jsxs("div", { className: "line-status", children: [isOperatorOnline ? (_jsx("span", { className: "line online" })) : (_jsx("span", { className: "line offline" })), _jsx("span", { className: "line-title", children: t("droneControlTopPanel.lineStatus.operator") }), _jsx("br", {}), isDroneOnline ? (_jsx("span", { className: "line online" })) : (_jsx("span", { className: "line offline" })), _jsx("span", { className: "line-title", children: t("droneControlTopPanel.lineStatus.drone") })] }), _jsx("div", { className: "usage-status", children: _jsx("div", { className: "usage-status-globe", children: t("droneControlTopPanel.remoteControl") }) }), _jsxs("div", { className: "gateway-wrapper", children: [showConnectionManagement && (_jsxs(_Fragment, { children: [_jsxs("span", { children: [t("droneControlTopPanel.gatewayLabel"), " ", InternetGateway[gatewayStatus]] }), !isViewOnly && (_jsx("div", { className: "gateway-select-wrapper", children: _jsxs("select", { name: "gateway", value: selectedGateway, onChange: (e) => {
                                            const value = e.target
                                                .value;
                                            const gateway = InternetGateway[value];
                                            switchInternetGateway(gateway);
                                        }, className: "gateway-select", children: [_jsx("option", { value: "Starlink", children: "Starlink" }), _jsx("option", { value: "Auto", children: "Auto" }), _jsx("option", { value: "LTE", children: "LTE" })] }) }))] })), _jsx("div", { className: "ping-wrapper", children: pingStats &&
                                Object.keys(pingStats).map((key) => (_jsx("div", { children: t("droneControlTopPanel.pingStats", {
                                        key,
                                        failed: pingStats[key].failedPings,
                                        avg: pingStats[key].averagePing,
                                    }) }, key))) })] })] }) }));
};
